import { render, staticRenderFns } from "./BuscaAnoNivelEtapa.vue?vue&type=template&id=efcd2018&"
import script from "./BuscaAnoNivelEtapa.vue?vue&type=script&lang=js&"
export * from "./BuscaAnoNivelEtapa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports